const createMuiAlertStyles = () => ({
    styleOverrides: {
        message: {
            width: '100%',
            padding: '10px 0',
        },
    },
});

export default createMuiAlertStyles;
